import type { State } from '../../types';
import type { ComputerViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function computersNotDeleted(state: State): ComputerViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.computersById).filter((e) => !e.deleted);
}
